module.exports = __webpack_public_path__ + "img/LUB00377.beef8d38.png";